var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dnd-grid-container",style:(_vm.style)},[_vm._t("default"),_c('box',{staticClass:"placeholder",attrs:{"boxId":"::placeholder::"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }